




















































































































import Vue from 'vue'
import Component from "vue-class-component";
import {Action} from "vuex-class";
import {cloneDeep, isEqual} from "lodash";
import {IvrMenuItem} from "@/store/call/ivr_menus/types";
import {InputWings, NumberWings, SelectWings, TextareaWings} from "wings-ui-components";
import {notifyConfirm, notifyDelete, notifyError} from '@/utils/notify-helper';
import {Ref} from "vue-property-decorator";
import PartnerSelectionCard from "@/components/Others/PartnerSelectionCard.vue";
import {MsgTransports} from "@/store/types";
import {md5} from "pure-md5";
import {PartnerItem} from "@/store/settings/partners/types";
import {getTranslatedParams} from "@/utils/notify-utils";
import {ActionLog} from "@/store/auth/types";

Component.registerHooks([
  'beforeRouteLeave',
])

@Component({components: {PartnerSelectionCard, SelectWings, NumberWings, InputWings, TextareaWings}})
export default class CallIvrMenu extends Vue {
  @Ref('validator') validator:any;

  @Action("getIvrMenuItem") actionGetItem: any;
  @Action("saveIvrMenu") actionSave: any;
  @Action("deleteIvrMenu") actionDelete: any;
  @Action("getPartners") actionGetPartners: any;
  @Action("actionLog") actionLog: any;

  partnersList: PartnerItem[] = [];
  partners: any = [];
  transport: MsgTransports = MsgTransports.CALL;
  file: File | undefined = undefined;


  defaultItem(): IvrMenuItem {
    return {
      name: "",
      path: null,
      service_number: null,
      partners: [],
      partner_ids: [],
      partner_id: null,
      description: null
    };
  }

  private item = this.defaultItem();
  private itemSaved = this.defaultItem();
  private logObject: ActionLog = {};

  async getPartnersList(filter: any) {
    const items = await this.actionGetPartners({ transport: this.transport, ...filter });
    this.partnersList = (filter?.page_number > 1) ? this.partnersList.concat(items) : items;
  }

  async created() {
    if (this.$route.params.id) {
      this.logObject = {
        action_page: this.$route.meta.msgKey,
        action: "Viewing",
        action_status: "success",
        object_type: "IVR menu",
        object_name: this.transport,
        addititional_info: getTranslatedParams(this.item)
      }
      await this.actionGetItem(this.$route.params.id).then(async (data: IvrMenuItem) => {
        this.item = Object.assign({},this.item, data);

        if (data.partners) {
          this.item.partner_ids = [];
          this.partners = [];
          data.partners.forEach((e: any) => {
            if (e.allowed) {
              this.item.partner_ids.push(e.id);
              this.partners.push({id: e.id, name: e.partner_name});
            }
          });
        }

        if (this.item.partner_id) {
          await this.getPartnersList({id: this.item.partner_id});
        }

        this.itemSaved = cloneDeep(this.item);
        this.logObject.object_name = this.item.name || this.transport;
        this.actionLog(this.logObject);
      }).catch(()=> this.actionLog({...this.logObject, action_status: "failed"}));
    }
  }

  back():void{
    this.$router.push('/call/ivr_menus/');
  }

  onSaveItem():Promise<void> {
    return new Promise<void>(async (resolve, reject) => {
      let valid:boolean = await this.validator.validate();
      if (!valid) {
        setTimeout(() => notifyError(null, this.validator.errors), 100);
        return;
      }
      try {
        const dataToSave: any = cloneDeep(this.item);
        if (!this.item.id) {
          if (this.file) {
            const fileData = await this.prepareFileData(this.file);
            dataToSave.file = fileData;
          }
        } else {
          if (this.file) {
            const fileData = await this.prepareFileData(this.file);
            dataToSave.file = fileData;
            delete dataToSave.path;
          } else {
            delete dataToSave.file;
          }
        }

        this.logObject = {
          action_page: this.$route.meta.msgKey,
          action: this.$route.params.id ? "Editing" : "Creation",
          action_status: "success",
          object_type: "IVR menu",
          addititional_info: getTranslatedParams(this.item)
        }
        await this.actionSave(dataToSave);
        await this.actionLog(this.logObject);
        this.itemSaved = cloneDeep(this.item);
        this.file = undefined;
        resolve();
        this.back();
      } catch (error) {
        this.actionLog({...this.logObject, action_status: "failed"});
        reject();
        notifyError(error);
      }
    })
  }

  async onDeleteItem():Promise<void> {
    let isConfirm:boolean = await notifyDelete();
    if (isConfirm) {
      try {
        this.logObject = {
          action_page: this.$route.meta.msgKey,
          action: "Removal",
          action_status: "success",
          object_type: "IVR menu",
          addititional_info: getTranslatedParams({id: this.item.id || this.$route.params.id})
        };
        await this.actionLog(this.logObject);
        await this.actionDelete(this.item);
        this.itemSaved = this.item;
        this.back();
      } catch (error) {
        this.actionLog({...this.logObject, action_status: "failed"});
        notifyError(error);
      }
    }
  }

  onFilePicked(file: File) {
    this.file = file;
    if (file && !this.item.path) {
      this.item.path = file.name;
    }
  }

  private async prepareFileData(file: File): Promise<{name: string, base64: string, md5: string}> {
    const readPromise = new Promise<any>((resolve, reject) => {
      let fr = new FileReader();
      fr.onerror = reject;
      fr.onload = () => resolve(new Uint8Array(<ArrayBuffer>fr.result));
      if (file) {
        fr.readAsArrayBuffer(file);
      } else {
        reject('No file')
      }
    });
    const byteArray: number[] = await readPromise;
    let fileString = '';
    const chunkSize = 8192;
    for (let i = 0; i < byteArray.length; i += chunkSize) {
      fileString += String.fromCharCode(...byteArray.slice(i, i + chunkSize));
    }
    return {
      name: file.name,
      base64: btoa(fileString),
      md5: md5(fileString)
    };
  }

  beforeRouteLeave(to: any, from: any, next: any) {
    let isChange = !isEqual(this.item,this.itemSaved);
    notifyConfirm(isChange, this.onSaveItem, next);
  }
}
